import React, { memo, FC } from "react";
import Typography from "@mui/material/Typography";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { spacerColor, spacerColorSdl } from "./defaults";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import useSpacerSelector from "./useSpacerSelector";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

const SpacerAccordian: FC = () => {
  const { isSDL, variant, checkMark, handleClick } = useSpacerSelector();
  const { readOnly } = useIsReadOnlyContextProviderContext();

  return (
    <ReusableAccordian
      accordionName="spacer"
      heading="IG Spacer Color"
      secondaryHeading="Select color"
    >
      <ColLayout>
        {isSDL && (
          <Typography variant="subtitle1">
            *Only available in Black with SDL
          </Typography>
        )}
        <RowLayout>
          {!isSDL
            ? spacerColor.map((state) => (
                <div key={state.id} onClick={() => readOnly ? null : handleClick(state.label)}>
                  <Choices
                    label={state.label}
                    disabled={readOnly}
                    variant={variant(state.label)}
                    checkMark={checkMark(state.label)}
                    wide={true}
                  />
                </div>
              ))
            : spacerColorSdl.map((state) => (
                <div key={state.id}>
                  <Choices
                    label={state.label}
                    disabled={true}
                    variant={"filled"}
                    checkMark={true}
                    wide={true}
                  />
                </div>
              ))}
        </RowLayout>
      </ColLayout>
    </ReusableAccordian>
  );
};

export default memo(SpacerAccordian);
